import { Button, Card, Chip, Icons, Stack, Typography } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { HistoryDto, HistoryDtoHistoryType, PatientBasicsDto } from '../../../api/generated/model';
import { formatDateWithGermanMonth } from '../../../utils/date.ts';
import { PatientAddressDisplay } from '../../components/patient-address/PatientAddressDisplay.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryHospitalizationOrIsolationEnded({
  history,
  patient,
}: {
  history: HistoryDto;
  patient: PatientBasicsDto;
}) {
  const navigate = useNavigate();
  return (
    <HistoryEntry
      history={history}
      subject={`${history.historyType === HistoryDtoHistoryType.ISOLATION_ENDED ? 'Isolation' : 'Hospitalisation'} von`}
      action={'wurde beendet von'}
      patient={patient}>
      <Card>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Stack gap={2}>
            {history.patientAddress && <PatientAddressDisplay patientAddress={history.patientAddress} />}
            <Stack direction={'row'} gap={0.5}>
              <Typography level={'title-sm'}>Beendet am:</Typography>
              <Chip size={'sm'}>{formatDateWithGermanMonth(history.created)}</Chip>
            </Stack>
          </Stack>
          <Stack alignItems={'start'}>
            <Button
              endDecorator={<Icons.ArrowForward />}
              onClick={() =>
                navigate({ to: '/patients/$patientId/therapy', params: { patientId: history.patientId } })
              }>
              Zur Therapie
            </Button>
          </Stack>
        </Stack>
      </Card>
    </HistoryEntry>
  );
}
